import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";

export default function Events() {

    const sections = [
    {
        id: "001",
        name: "Tennis",
        fee: "₦50,000 / year",
        dueDate: "2025-12-31",
    },
    {
        id: "002",
        name: "Swimming",
        fee: "₦35,000 / year",
        dueDate: "2025-11-15",
    },
    {
        id: "003",
        name: "Golf",
        fee: "₦120,000 / year",
        dueDate: "2026-01-20",
    },
    {
        id: "004",
        name: "Cultural",
        fee: "₦20,000 / year",
        dueDate: "2025-09-30",
    },
    ]

  return (
    <div className="flex flex-col">
        <h2 className="text-2xl font-bold mb-4">Member Dashboard</h2>
        <div className="grid md:grid-cols-2 gap-4">
            <div
              className="bg-white p-4 rounded shadow"
            >
              <div className="flex flex-col items-center pt-6">
                <img
                  src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQF02Jj8T2t7PdkytAw42HDuuSz7yXguKn8Lg&s'
                  className="w-20 h-20 rounded-full border-4 border-gray-200 mb-3"
                />
                <h3 className="text-lg font-semibold">{'Adekunle Adeyeye'}</h3>
                <span className="text-sm text-gray-500">
                  {'Lifetime'} Member
                </span>
              </div>
              <div className="text-center space-y-3 pb-2">
                <p className="text-sm text-gray-600">Age: {'30 years'}</p>
                <div
                  className={`inline-flex items-center gap-2 px-4 py-1 rounded-full text-sm font-medium ${'text-[#00b47a]'} ${'bg-[#bcffeaff]'}`}
                >
                  <FaRegCheckCircle className="w-4 h-4" />
                  {'Active'}
                </div>
              </div>
              <div className="text-center space-y-3 pb-4">
                <button className="bg-[#000080] text-[#7ace90] rounded-[5px] py-2 px-4">Edit Profile</button>
              </div>
            </div>
            <div className="bg-white p-4 rounded shadow">
                <h3 className="font-semibold mb-2">My Sections</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                    {sections.map((section) => (
                    <div key={section.id} className="rounded-[7px] border border-1 hover:cursor-pointer transition">
                        <div className="flex flex-col items-center space-y-2 pt-3">
                            <h3 className="text-lg font-semibold">{section.name}</h3>
                        </div>
                        <div className="text-center space-y-3 pb-4">
                        <div className="flex items-center justify-center gap-2 text-gray-700">
                            <p className="w-4 h-4 text-green-600"><del>N</del></p>
                            <span className="font-medium">{section.fee}</span>
                        </div>
                        <div className="flex items-center justify-center gap-2 text-gray-700">
                            <IoCalendarOutline className="w-4 h-4 text-red-600" />
                            <span className="text-sm">Next Due: {new Date(section.dueDate).toDateString()}</span>
                        </div>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
            <div className="bg-white p-4 rounded shadow">
                <h3 className="font-semibold mb-2">Upcoming Events</h3>
                <p className="font-regular mb-4 text-sm">Events this month</p>
                <div className="flex flex-col gap-y-2">
                    <div className="w-[max-content] px-3 py-2 bg-gray-200 rounded-[5px] flex flex-row items-center gap-x-3"><IoCalendarOutline /><p className="text-sm">Club Anniversary Dinner – Oct 5</p></div>
                    <div className="w-[max-content] px-3 py-2 bg-gray-200 rounded-[5px] flex flex-row items-center gap-x-3"><IoCalendarOutline /><p className="text-sm">Club Anniversary Dinner – Oct 5</p></div>
                    <div className="w-[max-content] px-3 py-2 bg-gray-200 rounded-[5px] flex flex-row items-center gap-x-3"><IoCalendarOutline /><p className="text-sm">Club Anniversary Dinner – Oct 5</p></div>
                </div>
            </div>
            <div className="bg-white p-4 rounded shadow">
                <h3 className="font-semibold mb-2">Events Calendar</h3>
                <EventCalendar />
            </div>
        </div>
    </div>
  );
}
